export default __webpack_public_path__ + "static/media/Mobile-Dale.cf985abe.svg";